<template>
    <tr v-show="show">
        <td>{{tag.name}}</td>
        <td>sample</td>
        <td></td>
        <td>2017/08/09 10:00</td>
        <td>
            <!--<input type="checkbox" v-model="tag.check">-->
            <BtnDelete v-on:delete="deleteAction"></BtnDelete>
        </td>
    </tr>
</template>

<script>
  import BtnDelete from '@/components/BtnDelete.vue'
  export default {
    created: function () {
    },
    data () {
      return {
        show: true
      }
    },
    props: ['tag'],
    components: {
      BtnDelete
    },
    methods: {
      deleteAction: function () {
        this.show = false
      }
    }
  }
</script>




// WEBPACK FOOTER //
// ListRow.vue?b9fda5a4